import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, LIST_ALL_STORE_ORDER_LIST } from "../../../Constants/Config";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  inStoreOrderData: [],
  OrderListCount: 0,
  successMessage: "",
  error: "",
  latestOrderDataRequestId: null,
  latestOrderDataCountRequestId: null,
  // listCoutLoading:false,
};
let OrderDataAbortController = null;
let OrderDataCountController = null;
// Generate pening , fulfilled and rejected action type
export const fetchInStoreOrderData = createAsyncThunk(
  "inStoreOrder/fetchInStoreOrderData.",
  async (data, { rejectWithValue, requestId }) => {
    if (OrderDataAbortController) {
      OrderDataAbortController.abort();
    }

    OrderDataAbortController = new AbortController();

    const signal = OrderDataAbortController.signal;

    const { userTypeData } = useAuthDetails();
    const { token, ...otherUserData } = userTypeData;
    try {
      const response = await axios.post(
        BASE_URL + LIST_ALL_STORE_ORDER_LIST,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal, // Pass the signal for cancellation
        }
      );
      // console.log(response)
      if (response.data.status === true) {
        return { requestId, data: response.data.order_data };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
        requestId,
      };
      return rejectWithValue(customError);
    }
  }
);
export const getOrderListCount = createAsyncThunk(
  "inStoreOrder/getOrderListCount",
  async (data, { rejectWithValue, requestId }) => {
    try {
      if (OrderDataCountController) {
        OrderDataCountController.abort();
      }

      OrderDataCountController = new AbortController();

      const signal = OrderDataCountController.signal;
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + "Order_list_api/all_order_list_count",
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
          signal,
        }
      );
      // console.log("AllInStoreDataState OrderListCount: ", response.data.order_data);
      if (response.status == 200) {
        return { requestId, data: response.data.order_data };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const inStoreOrderSlice = createSlice({
  name: "inStoreOrder",
  initialState,
  reducers: {
    updateInstoreOrderDataState: (state) => {
      state.inStoreOrderData = [];
      state.OrderListCount = 0;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInStoreOrderData.pending, (state, action) => {
      state.loading = true;
      state.latestOrderDataRequestId = action.meta.requestId;
    });
    builder.addCase(fetchInStoreOrderData.fulfilled, (state, action) => {
      if (state.latestOrderDataRequestId !== action.payload.requestId) {
        return; // Ignor outdated errors
      }
      state.loading = false;
      state.inStoreOrderData = action.payload.data;
      state.error = "";
    });
    builder.addCase(fetchInStoreOrderData.rejected, (state, action) => {
      if (state.latestOrderDataRequestId !== action.payload.requestId) {
        return; // Ignor outdated errors
      }
      if (action.payload?.message === "Request canceled") {
        return; // Do nothing if canceled, keep loading true
      }

      state.loading = false;
      state.inStoreOrderData = {};
      state.error = action.error.message;
    });
    builder.addCase(getOrderListCount.pending, (state, action) => {
      // state.listCoutLoading = true;
      state.latestOrderDataCountRequestId = action.meta.requestId;
    });
    builder.addCase(getOrderListCount.fulfilled, (state, action) => {
      if (state.latestOrderDataCountRequestId !== action.payload.requestId) {
        return; // Ignor outdated errors
      }
      state.OrderListCount = action.payload.data;
    });
    builder.addCase(getOrderListCount.rejected, (state, action) => {
      if (state.latestOrderDataCountRequestId !== action.payload.requestId) {
        return; // Ignor outdated errors
      }
      if (action.payload?.message === "Request canceled") {
        return; // Do nothing if canceled, keep loading true
      }
      state.OrderListCount = 0;
    });
  },
});
export const { updateInstoreOrderDataState } = inStoreOrderSlice.actions;
export default inStoreOrderSlice.reducer;
